/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Header_Admin_SettingsInputs */

const es_billing_header_admin_settings = /** @type {(inputs: Billing_Header_Admin_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel Admin`)
};

const en_billing_header_admin_settings = /** @type {(inputs: Billing_Header_Admin_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin panel`)
};

/**
* | output |
* | --- |
* | "Admin panel" |
*
* @param {Billing_Header_Admin_SettingsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const billing_header_admin_settings = /** @type {((inputs?: Billing_Header_Admin_SettingsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Header_Admin_SettingsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_billing_header_admin_settings(inputs)
	return en_billing_header_admin_settings(inputs)
});
export { billing_header_admin_settings as "billing.header.admin_settings" }